import React from "react";
import TitleToolTip from "./TitleToolTip";

const LabelToolTip = (props) => {
  const { label, labelLengthToShow = 30 } = props;
  return label.length <= labelLengthToShow ? (
    // if length is smaller than the labelLengthToShow then show the label without tooltip
    label
  ) : (
    <TitleToolTip
      title={label}
      children={
        <span>
          {String(label).slice(0, labelLengthToShow) +
            (label.length > labelLengthToShow ? "..." : "")}
        </span>
      }
    />
  );
};

export default LabelToolTip;
